import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";

const AllOrderRequestTable = ({
  tableData,
  setSortField,
  setSortOrder,
  sortOrder,
}) => {
  const rows = Array.isArray(tableData) ? tableData : (tableData?.data ?? []);

  const handleSortById = () => {
    setSortField("unique_id");
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const formatCurrency = (value) =>
    typeof value === "number" ? value.toFixed(2) : "-";

  const formatDate = (value) =>
    value
      ? new Date(value).toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      })
      : "-";

  const getIndicator = () => (sortOrder === "asc" ? "↑" : "↓");

  return (
    <div className="rounded-md  overflow-hidden">
      <div className="overflow-x-auto overflow-y-hidden">
        <Table className="w-full">
          <TableHeader>
            <TableRow className=" hover:bg-transparent">
              <TableHead
                className="w-[160px] cursor-pointer select-none text-white whitespace-nowrap"
                onClick={handleSortById}
              >
                <div className="flex items-center gap-1">
                  ID <span className="text-xs">{getIndicator()}</span>
                </div>
              </TableHead>
              <TableHead className="text-white whitespace-nowrap">
                Date / Time
              </TableHead>
              <TableHead className="text-white whitespace-nowrap">
                Name
              </TableHead>
              <TableHead className="text-white whitespace-nowrap">
                Phone
              </TableHead>
              <TableHead className="text-white whitespace-nowrap">
                Items
              </TableHead>
              <TableHead className="text-white whitespace-nowrap">
                Price
              </TableHead>
              <TableHead className="text-white whitespace-nowrap">
                Payment Type
              </TableHead>
              <TableHead className="text-white whitespace-nowrap">
                Order Type
              </TableHead>
              <TableHead className="text-right text-white whitespace-nowrap">
                Actions
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow className="">
                <TableCell colSpan={9}>
                  <div className="py-6 text-center text-white/70">
                    Data not found.
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((order) => {
                const orderId = order?.unique_id ?? `#${order?.id}`;
                return (
                  <TableRow key={order?.id} className=" hover:bg-white/5">
                    <TableCell className="max-w-[160px]">
                      <div className="truncate text-white" title={orderId}>
                        {orderId}
                      </div>
                    </TableCell>
                    <TableCell className="text-white whitespace-nowrap">
                      {formatDate(order?.created_at)}
                    </TableCell>
                    <TableCell className="text-white whitespace-nowrap">
                      {order?.customer_info?.customer_name || "N/A"}
                    </TableCell>
                    <TableCell className="text-white whitespace-nowrap">
                      {order?.customer_info?.phone_number || "N/A"}
                    </TableCell>
                    <TableCell className="text-white">
                      {order?.items?.length ?? "-"}
                    </TableCell>
                    <TableCell className="text-white">
                      {formatCurrency(order?.total_amount)}
                    </TableCell>
                    <TableCell className="text-white whitespace-nowrap capitalize">
                      {order?.payment_method?.replaceAll("_", " ") ?? "-"}
                    </TableCell>
                    <TableCell className="text-white whitespace-nowrap capitalize">
                      {order?.order_type?.replaceAll("_", " ") ?? "-"} {(order?.order_summary?.pre_order?.is_pre_order && <span className="text-cred">(Pre)</span>) || ""}
                    </TableCell>
                    <TableCell>
                      <div className="flex justify-end mr-2 gap-3 text-white">
                        <Link
                          to={`/onlineordering/website-ordering/order-request/${order?.id}`}
                          className="transition-colors"
                        >
                          <Eye size={16} />
                        </Link>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default AllOrderRequestTable;
